<script setup>
import { ref, onMounted } from 'vue'

const isSend = ref(false)

const sendComment = () => {
  isSend.value = true
}

const comments = [
  { name: "Иван", comment: "Сегодня отличная погода!" },
  { name: "Ольга", comment: "Вдохновляюсь утренним кофе ☕." },
  { name: "Алексей", comment: "Купил новый велосипед, теперь каждый день на велопрогулки!" },
  { name: "Марина", comment: "Читаю новую книгу, сюжет завораживает." },
  { name: "Дмитрий", comment: "Вышла новая серия моего любимого сериала!" },
  { name: "Светлана", comment: "Кто тоже ждет выходных? 😅" },
  { name: "Анна", comment: "Готовлю торт на день рождения сына 🎂." },
  { name: "Максим", comment: "Наконец-то купил билеты на концерт!" },
  { name: "Екатерина", comment: "В поисках новых рецептов на ужин." },
  { name: "Юрий", comment: "Давно не было такой продуктивной недели." },
  { name: "Татьяна", comment: "Посадила новые цветы на даче 🌸." },
  { name: "Сергей", comment: "Кто пробовал новый ресторан в центре города?" },
  { name: "Елена", comment: "Осень - лучшее время для прогулок в парке 🍂." },
  { name: "Павел", comment: "Смотрю старые фильмы, так много ностальгии." },
  { name: "Виктория", comment: "Записалась на йогу, чувствую себя лучше." },
  { name: "Кирилл", comment: "Мой кот опять своровал мою еду 🐱." },
  { name: "Алиса", comment: "На выходных планирую сходить в музей." },
  { name: "Игорь", comment: "Обожаю утренние пробежки, так заряжают!" },
  { name: "Наталья", comment: "Готовлю проект для работы, много идей." },
  { name: "Роман", comment: "Купил новые наушники, звук просто шикарный!" },
  { name: "Владимир", comment: "Собираю пазлы, это так расслабляет." },
  { name: "Анастасия", comment: "Провела день с друзьями, это было весело!" },
  { name: "Григорий", comment: "Научился готовить борщ, теперь горжусь собой." },
  { name: "Юлия", comment: "Вышла на работу после отпуска, столько задач!" },
  { name: "Даниил", comment: "Играл в шахматы с другом, это так увлекательно." },
  { name: "Вероника", comment: "Купила новый шарф, он такой теплый и уютный." },
  { name: "Константин", comment: "Записываю подкаст о путешествиях, столько впечатлений." },
  { name: "Лидия", comment: "Пеку пирожки с вишней, аромат на весь дом." },
  { name: "Артем", comment: "Планирую путешествие в горы на следующий месяц." },
  { name: "Ирина", comment: "Рассматриваю старые фотографии, столько воспоминаний." },
  { name: "Олег", comment: "Сделал генеральную уборку, теперь везде чисто!" },
  { name: "Полина", comment: "Рисую новую картину, надеюсь, получится хорошо." },
  { name: "Борис", comment: "Закончил ремонт в квартире, теперь она как новая!" },
  { name: "София", comment: "Пробую учить новый язык, это сложно, но интересно." },
  { name: "Аркадий", comment: "Кто-то еще играет в настольные игры? Это так здорово!" },
  { name: "Евгения", comment: "Нашла новый сериал, смотрю запоем!" },
  { name: "Тимур", comment: "Взял отпуск, думаю поехать на море." },
  { name: "Алёна", comment: "Заказала новую технику на кухню, не терпится попробовать." },
  { name: "Степан", comment: "Мой пес сегодня был особенно веселый 🐕." },
  { name: "Вера", comment: "Делаю подарки своими руками, это так увлекательно." },
  { name: "Федор", comment: "Сходил на выставку, узнал столько нового." },
  { name: "Дарья", comment: "Читаю интересную статью о психологии." },
  { name: "Леонид", comment: "Научился кататься на роликах, теперь каждый день тренируюсь." },
  { name: "Агата", comment: "Посмотрела фильм, который давно откладывала. Очень понравился!" },
  { name: "Петр", comment: "Начал ремонт в доме, это настоящее приключение." },
  { name: "Елизавета", comment: "Купила билет в театр, жду с нетерпением." },
  { name: "Захар", comment: "Собираю коллекцию старинных монет, это увлекательно." },
  { name: "Милана", comment: "Осваиваю новый музыкальный инструмент, это непросто." },
  { name: "Андрей", comment: "Посмотрел матч вчера, наши победили!" }
];

</script>


<style lang="scss">

</style>

<template>
  <div class="comments" :style="{marginTop: 0}">
      <!-- <h2 class="comments__title">Добавить сообщение</h2>
      <div class="comments__moder" v-if="isSend">
          Ваше сообщение отправлено на модерацию
      </div> -->
      <!-- <form action="" v-else class="comments__form" @submit.prevent="sendComment">
          <input type="text" placeholder="Имя" required>
          <input type="text" placeholder="Текст" required>
          <button class="btn" type="submit">Отправить</button>
      </form> -->
      <div class="comment" v-for="(comment, index) in comments" :key="index">
          <span>{{ comment.name }}</span>
          <div>{{ comment.comment }}</div>
      </div>
  </div>
</template>